import HomeBanner from "../assets/images/customer/banner_image.png";
import ImageBuyProperty from "../assets/images/customer/BrowserProperty/BuyProperty.png";
import ImageSellHomeProperty from "../assets/images/customer/BrowserProperty/SellHome.png";
import ImageNewHomeProperty from "../assets/images/customer/BrowserProperty/NewHome.png";
import Footer from "../assets/images/footer.png";
import ImagePropertyOverview from "../assets/images/customer/Property/property-overview.png";
import ImageCollection1 from "../assets/images/customer/Property/collection1.webp";
import ImageCollection2 from "../assets/images/customer/Property/collection2.webp";
import ImageEmptySavedSearch from "../assets/images/customer/Empty/SavedSearch.png";
import ImageEmptyManageTours from "../assets/images/customer/Empty/ManageTours.png";
import ImageEmptyRecentlyViews from "../assets/images/customer/Empty/RecentlyViews.png";
import ImageEmptyYourProperty from "../assets/images/customer/Empty/YourProperty.png";
import IMAGE_USER_DEFAULT from "../assets/images/customer/Empty/image.png";
import IMAGE_ABOUT from "../assets/images/about.jpg";
import IMAGE_KEY_PRINCIPLES from "../assets/images/key-principles.jpg";
import IMAGE_AMENITIES_ICON from "../assets/images/amenities-default-icon.png";
import ImageNotFound from "../assets/images/image-not-found.png";

const FetchImages = {
  ImageNotFound,
  HOME_BANNER: HomeBanner,
  ImagePropertyOverview,
  ImageBuyProperty,
  IMAGE_KEY_PRINCIPLES,
  IMAGE_ABOUT,
  ImageSellHomeProperty,
  ImageNewHomeProperty,
  FOOTER: Footer,
  ImageCollection1,
  ImageCollection2,
  ImageEmpty_SavedSearch: ImageEmptySavedSearch,
  ImageEmpty_ManageTours: ImageEmptyManageTours,
  ImageEmpty_RecentlyViews: ImageEmptyRecentlyViews,
  ImageEmpty_YourProperty: ImageEmptyYourProperty,
  IMAGE_USER_DEFAULT: IMAGE_USER_DEFAULT,
  IMAGE_AMENITIES_ICON,
};

export default FetchImages;
